/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { PortionCategoryBase } from 'shared/dbo/PortionCategory';

export interface PortionCategoryIndexedDb {
	id: string;
	categoryName: string;
	quantityMultiplier: number;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isPortionCategoryIndexedDb = (obj: unknown): obj is PortionCategoryIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ categoryName: unknown }>(obj, 'categoryName') || !(typeof obj.categoryName === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ quantityMultiplier: unknown }>(obj, 'quantityMultiplier') || !(typeof obj.quantityMultiplier === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: PortionCategoryBase): PortionCategoryIndexedDb => ({
	id: obj.id.toString(),
	categoryName: obj.categoryName,
	quantityMultiplier: obj.quantityMultiplier,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: PortionCategoryIndexedDb): PortionCategoryBase => ({
	id: UUID.fromString(obj.id),
	categoryName: obj.categoryName,
	quantityMultiplier: obj.quantityMultiplier,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdPortionCategory: LocalDatabaseTableDefinition<PortionCategoryBase, PortionCategoryIndexedDb> = {
	tableName: 'portionCategories',
	indexColumns: [],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
